import * as React from 'react';
import Fields from './Fields';
import { PkpassFieldsType } from '../../../../types';
export default function PrimaryFields() {
  return /*#__PURE__*/React.createElement(Fields, {
    fieldsType: PkpassFieldsType.PrimaryFields
  });
}
//# sourceMappingURL=PrimaryFields.js.map